<template>
  <b-row>
    <b-col cols="12">
      <h2>
        Withdrawal Requests
      </h2>

      <div v-if="errors.length" class="alert alert-danger">
        <ul>
          <li v-for="error in errors" :key="error.msg">
            {{ error.msg }}
          </li>
        </ul>
      </div>

      <b-table striped hover :items="withdrawals" :fields="fields">
        <template slot="actions" slot-scope="row">
          <b-btn
            size="sm"
            :to="{ name: 'WithdrawalDetail', params: { id: row.item._id } }"
            >Show</b-btn
          >
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import API from '@/api';

export default {
  name: 'WithdrawalsList',
  data() {
    return {
      fields: {
        createdAt: { label: 'Request Timestamp', sortable: true },
        approvedDate: { label: 'Sent Timestamp', sortable: true },
        userUuid: { label: 'UUID', sortable: true },
        amount: {
          label: 'Amount',
          formatter: value => {
            return '$' + (value / 100).toFixed(2);
          },
          sortable: true
        },
        paypalEmail: {
          label: 'Paypal Email',
          class: 'text-center',
          sortable: true
        },
        status: { label: 'Status', sortable: true },
        paypalIdentifier: { label: 'Confirmation', sortable: true },
        actions: { label: 'Action', sortable: true }
      },
      withdrawals: [],
      errors: [],
      currentPage: 0,
      perPage: 10
    };
  },
  created() {
    this.reloadList();
  },
  methods: {
    reloadList() {
      this.errors = [];
      API.get('admin/withdrawal/list').then(res => {
        if (res.status === 'ok') {
          for (let i = 0; i < res.data.withdrawals.length; i++) {
            res.data.withdrawals[i].status = res.data.withdrawals[i]
              .approvedDate
              ? 'Sent'
              : 'Requested';
          }
          this.withdrawals = res.data.withdrawals;
        } else {
          this.errors = res.errors;
        }
      });
    }
  }
};
</script>
